<template>
  <section class="cw-panel cw-stack" :aria-busy="busy">
    <div><h3>V2 vollständig zurücksetzen</h3><p class="cw-small">Erstellte V2-Verträge, Angebote, Aktionen und V2-Einstellungen aller Center löschen. Danach kannst du die aktivierten contractShells neu importieren.</p></div>
    <p class="cw-note">Bestehende Kundenaccounts, alte Verträge und die bisherigen contractShells bleiben erhalten. Der Reset gilt für WELL COME FIT und WINTI FIT gemeinsam.</p>
    <p v-if="error" class="cw-error" role="alert">{{ error }}</p>
    <p v-if="done" class="cw-notice" role="status">{{ done }}</p>
    <template v-if="preview && !done">
      <div class="cw-admin-fields"><div v-for="row in preview.counts" :key="row.key" class="cw-panel"><strong>{{ row.count }}</strong><p class="cw-small">{{ row.label }}</p></div></div>
      <div v-if="preview.blockers.length" class="cw-note"><strong>Der Reset ist noch gesperrt.</strong><ul><li v-for="message in preview.blockers" :key="message">{{ message }}</li></ul></div>
      <p v-if="paused" class="cw-note" role="status">Der Reset wurde unterbrochen. V2 bleibt währenddessen gesperrt. Du kannst denselben Reset fortsetzen; bereits erledigte Schritte werden nicht wiederholt.</p>
      <template v-if="!preview.blockers.length">
        <label class="cw-check"><input v-model="confirmed" type="checkbox" :disabled="busy || !!pending">Ich möchte die oben aufgeführten V2-Daten aller Center unwiderruflich löschen.</label>
        <label class="cw-label">Zur Bestätigung {{ preview.confirmation }} eingeben<input v-model="confirmation" class="cw-input" autocomplete="off" spellcheck="false" :disabled="busy || !!pending"></label>
        <button class="cw-button" type="button" :disabled="!canReset" @click="reset">{{ busy ? 'Reset wird ausgeführt …' : paused ? 'Reset fortsetzen' : pending ? 'Reset-Ergebnis erneut prüfen' : 'V2-Daten jetzt löschen' }}</button>
      </template>
    </template>
    <div class="cw-row"><button v-if="!paused" class="cw-button" type="button" :disabled="busy || !!pending" @click="inspect">{{ busy ? 'V2-Daten werden geprüft …' : preview ? 'Vorschau aktualisieren' : 'Reset-Vorschau laden' }}</button><button class="cw-button" type="button" :disabled="busy || !!pending" @click="$emit('close')">{{ done ? 'Zur Datenübernahme' : 'Zurück' }}</button></div>
  </section>
</template>

<script>
import api, { errorMessage } from "@/api/contractWorkspaceApi"

export default {
  name: "ContractWorkspaceReset",
  data: () => ({ preview: null, busy: false, error: "", done: "", confirmed: false, confirmation: "", paused: false, pending: null }),
  computed: {
    canReset() { return !this.busy && (!!this.pending || !!this.preview && !this.preview.blockers.length && this.confirmed && this.confirmation === this.preview.confirmation) },
  },
  methods: {
    setBusy(value) { this.busy = value; this.$emit("busy", value) },
    async inspect() {
      if (this.busy || this.pending) return
      this.setBusy(true); this.error = ""; this.done = ""; this.confirmed = false; this.confirmation = ""
      try {
        this.preview = await api.previewWorkspaceReset()
        this.paused = this.preview.status === "paused"
      } catch (error) { this.error = errorMessage(error) }
      finally { this.setBusy(false) }
    },
    async reset() {
      if (!this.canReset) return
      if (!this.pending) this.pending = { token: this.preview.token, fingerprint: this.preview.fingerprint, confirmation: this.confirmation }
      this.$emit("dirty", true)
      this.setBusy(true); this.error = ""
      try {
        const result = await api.resetWorkspace(this.pending)
        this.paused = result.status === "paused"
        if (result.status === "complete") { this.pending = null; this.$emit("dirty", false); this.done = "V2 ist zurückgesetzt. Du kannst jetzt die aktivierten contractShells für alle Center neu importieren."; this.$emit("reset") }
        else this.error = result.message || "Der Reset ist noch nicht abgeschlossen. Bitte fortsetzen."
      } catch (error) {
        this.error = errorMessage(error)
        if (error.response && [400, 401, 403, 409, 423].includes(error.response.status)) { this.pending = null; this.$emit("dirty", false) }
        // Keep the exact token after a lost response: retrying must never start a second reset.
      } finally { this.setBusy(false) }
    },
  },
}
</script>
